module.exports = __webpack_public_path__ + "img/img_01.d97f641c.png";